export default {
    id: "b9459d99-61b2-4403-8f65-813b7da2993c",
    icon: "mdi-minus",
    name: "shapeLine",
    title: "Shape Line",
    description: "A block line",
}